/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState, useRef, useCallback} from 'react';

// material
import {SingleSelectDropDown, Group, Note,DateRangePickerDropDown} from '@insticator/insticator-ui'; // iui-material
import SectionGroup from "../../../../../material/expandablesection/sectiongroup/sectiongroup";

// utils

// redux
import {useDispatch, useSelector} from "react-redux";
import {updateReportForm} from "../../../../../state/slices/report";

//components
import Period from '../filter/period/period';

// statics
import {
    PERIOD_AGG,
    REPORT_NAME,
    REPORT_NAME_LENGTH,
    FILTERS,
    REPORT_CREATED,
    PERIOD_AGG_OPTIONS,
    REPORT_NAME_DUPLICATED_ERROR_TEXT,
    REPORT_NAME_ERROR_TEXT,
    DATE_OPTIONS_REPORT_BUILDER, DATE_OPTIONS_INFO
} from "../consts";

// styles
import injectSheet from 'react-jss';
import styles from './generalsettings_styles';

//icons
import { ReactComponent as Condition } from "assets/icons/condition.svg";


/* ========== ~~~~~~~~~~ METRICS FORM ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) => {
    const formValues = useSelector((state) => state.report[props.uuid]);
    const allReports = useSelector((state) => state.report.allReports);
    const reportNames = allReports.filter(r => r.reportUUID !== props.uuid).map(r => r[REPORT_NAME] && r[REPORT_NAME].toLowerCase());
    
    const dispatch = useDispatch();

    const [formErrors, setFormErrors] = useState({});
    const inputField = useRef(null);
    const defaultPeriod = formValues.dateRange || 'CUSTOM'
    const [selectedPeriod, setSelectedPeriod] = useState(defaultPeriod);
    const immediateValues = useRef({});

    useEffect(() => {
        // Validate on formValues or allReports change
        if (formValues[REPORT_NAME]) {
            validateReportName(formValues[REPORT_NAME]);
        }
    }, [formValues, allReports]);

    useEffect(() => {
        setSelectedPeriod(formValues.dateRange || 'CUSTOM');
    },[formValues])

    const validateReportName = (reportName) => {
        if (reportName) {
            if (reportNames.includes((reportName || '').toLowerCase())) {
                setFormErrors({ [REPORT_NAME]: REPORT_NAME_DUPLICATED_ERROR_TEXT });
            } else {
                setFormErrors({ [REPORT_NAME]: '' });
            }
        } else {
            setFormErrors({ [REPORT_NAME]: REPORT_NAME_ERROR_TEXT });
        }
    };

    useEffect(() => {
        inputField.current.focus();
    }, [])

    const handleOnChange = newValues => {
        dispatch(updateReportForm({...formValues, ...newValues}));
    }

    const createdAtDateFormat = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    const createAt = new Date(formValues[REPORT_CREATED]).toLocaleString('en-US', createdAtDateFormat)

    return (
        <div className={props.classes.reportSettings}>
            <SectionGroup row>
                <Group>
                    <h3>Details</h3>
                    <label>Name</label>
                    <div className='formelement'>
                        <input
                            maxLength={REPORT_NAME_LENGTH}
                            placeholder={'Enter name...'}
                            className='textfield'
                            name={REPORT_NAME}
                            type='text'
                            value={formValues[REPORT_NAME]}
                            onBlur={(e) => {
                                const {
                                    target: {name, value},
                                } = e;
                                handleOnChange({[name]: value});
                                // Synchronous validation
                                validateReportName(value);
                            }}
                            onChange={(e) => {
                                const { name, value } = e.target;
                                handleOnChange({ [name]: value });
                            }}
                            ref={inputField}
                        />
                    </div>
                    <Note>
                        <p>{`Report name can be up to ${REPORT_NAME_LENGTH} characters`}</p>
                    </Note>
                    {formErrors[REPORT_NAME] && document.activeElement !== inputField.current && (
                        <p className={props.classes.errorText}>{formErrors[REPORT_NAME]}</p>
                    )}
                </Group>
            </SectionGroup>
            <SectionGroup row>
                <Group className={props.classes.dateGroup}>
                    <label>Period</label>
                    <div className={props.classes.filter}>
                        <SingleSelectDropDown
                            items={DATE_OPTIONS_REPORT_BUILDER}
                            name={'Select a date range'}
                            searchable={false}
                            onSelect={(e) => {
                                setSelectedPeriod(e.value);
                                handleOnChange({['dateRange']: e.value});
                            }}
                            selected={DATE_OPTIONS_REPORT_BUILDER.find((p) => p.value === selectedPeriod)}
                        ></SingleSelectDropDown>
                        {selectedPeriod === 'CUSTOM' ?
                            <Period handleOnChange={handleOnChange} uuid={props.uuid}/> : null}
                    </div>
                </Group>
            </SectionGroup>
            <div className={props.classes.infoGroup}>
                {selectedPeriod === 'CUSTOM' && <div className={props.classes.dateInfo}>
                    <span><Condition></Condition></span>
                    <div>
                        <div>You will not be able to schedule this report with a custom period. If you would</div>
                        <div>like to set a recurring report schedule, please select a preset time period.</div>
                    </div>

                </div>}
            </div>

        </div>
    );
});
